import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, object=logged in
  const [demoMode, setDemoMode] = useState(false);

  const check = useCallback(async () => {
    try {
      const me = await auth.me();
      setUser(me);
      setDemoMode(!!me.demoMode);
    } catch { setUser(false); }
  }, []);

  useEffect(() => { check(); }, [check]);

  const loginAdmin = async (password) => { const r = await auth.login(password); if (r?.token) setToken(r.token); await check(); };
  const loginUser = async (email, password) => { const r = await auth.loginUser(email, password); if (r?.token) setToken(r.token); await check(); };
  const logout = async () => { try { await auth.logout(); } catch {} clearToken(); setUser(false); };

  const isOwner = user && user.role === "owner";
  const can = (perm) => !!user && (user.role === "owner" || (user.permissions || []).includes(perm));

  return (
    <AuthContext.Provider value={{ user, demoMode, isOwner, can, loginAdmin, loginUser, logout, refreshMe: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
